import React, { type ComponentProps, type PropsWithChildren } from 'react';

import { LabelText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Label = (props: Props) => {
  const { children, sizeMatch = DEFAULT_SIZE_MATCH } = props;

  return (
    <LabelText sizeMatch={sizeMatch} maxFontSizeMultiplier={1.2}>
      {children}
    </LabelText>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_SIZE_MATCH: SizeMatch = ['14'];

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  sizeMatch?: SizeMatch;
}>;

type SizeMatch = ComponentProps<typeof LabelText>['sizeMatch'];
